import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import PolyboinicLogo from "../../src/image/Polyboinic-Technologies-Logo.png";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#69B89A] text-white">
      <div className="max-w-7xl mx-auto px-6 md:py-16 py-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4 lg:grid-cols-4  ">
          {/* Logo */}
          <div>
            <img src={PolyboinicLogo} alt="Polybionic" className="h-32 mb-4" />
            <p className="text-sm text-white/80">
              Driving sustainable energy solutions for homes, businesses, and
              industries.
            </p>
          </div>

          {/* Pages */}
          <div>
            <h3 className="text-xl font-bold mb-2 md:mb-6 ">Quick Links</h3>

            <ul className="space-y-3">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/our-solutions">Our Solutions</Link>
              </li>
              <li>
                <Link to="/projects">Projects</Link>
              </li>
              <li>
                <Link to="/join-us">Join Us</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-2 md:mb-6">Contact</h3>

            <div className="space-y-4">
              <p className="flex items-center gap-3">
                <FaEnvelope />
                info@polybionictechnologies.com
              </p>

              <p className="flex items-center gap-3">
                <FaPhoneAlt />
                +91 0172 456 1505
              </p>

              <p className="flex items-start gap-3">
                <FaMapMarkerAlt className="mt-1" />
                District- Mohali, Punjab, India
              </p>
            </div>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-xl font-bold mb-2 md:mb-6">Follow Us</h3>

            <div className="flex gap-4">
              <a
                href="#"
                className="w-11 h-11 rounded-full bg-white text-[#69B89A] flex items-center justify-center hover:scale-110 transition"
              >
                <FaFacebookF />
              </a>

              <a
                href="https://www.instagram.com/polybionictechnologies?stkn=bmJrMTh0OGxiMzZ1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full bg-white text-[#69B89A] flex items-center justify-center hover:scale-110 transition"
              >
                <FaInstagram />
              </a>

              <a
                href="#"
                className="w-11 h-11 rounded-full bg-white text-[#69B89A] flex items-center justify-center hover:scale-110 transition"
              >
                <FaYoutube />
              </a>

              <a
                href="#"
                className="w-11 h-11 rounded-full bg-white text-[#69B89A] flex items-center justify-center hover:scale-110 transition"
              >
                <FaTwitter />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-6 md:mt-12 pt-6 text-center text-sm">
          © {new Date().getFullYear()} Polybionic Technologies. All Rights
          Reserved.
        </div>
      </div>
    </footer>
  );
}
